<template>
  <div style="padding: 15px 10px;">
    <el-row class="line button">
      <el-button icon="el-icon-circle-plus-outline"
                 size="small" @touchstart="openDialog()" @click="openDialog()">
        新增策略
      </el-button>
      <span style="margin-left: 20px;"   v-if="groupCode[0] !== 'special'">
         告警等级：
        <el-select
          placeholder="请选择"
          size="mini"
          @change="getDataInfo"
          style="padding-bottom: 5px;width: 10%;"
          clearable
          filterable
          v-model="alarmLevel">
              <el-option
                :key="item.id"
                :label="item.levelName"
                :style="{color: item.levelColor}"
                :value="item.id"
                v-for="item in levelList">
              </el-option>
            </el-select>
      </span>
      <span style="margin-left: 20px;" v-if="groupCode=='ordinary'">
         设备类型：
        <el-select
          placeholder="请选择"
          size="mini"
          @change="getDataInfo"
          style="padding-bottom: 5px;width: 10%;"
          clearable
          filterable
          v-model="deviceCategory">
              <el-option
                :key="item.id"
                :label="item.cnName"
                :value="item.id"
                v-for="item in deviceCategoryList">
              </el-option>
            </el-select>
      </span>
      <span style="margin-left: 20px;" v-if="groupCode!='ordinary'">
        主机：
        <el-select
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px;width: 10%;"
          @change="screenGateway"
          clearable
          filterable
          v-model="gatewaySn">
              <el-option
                :key="item.id"
                :label="item.name"
                :value="item.snCode"
                v-for="item in gatewayList">
              </el-option>
            </el-select>
      </span>
      <span style="margin-left: 20px;" v-if="groupCode=='special'">
        设备：
        <el-select
          placeholder="请选择"
          size="mini"
          @change="changeDeviceId"
          style="padding-bottom: 5px;width: 10%;"
          clearable
          filterable
          v-model="deviceId">
              <el-option
                :key="item.id"
                :label="item.name"
                :value="item.id"
                v-for="item in screenDeviceList">
              </el-option>
            </el-select>
      </span>

      <span style="margin-left: 20px;" v-if="groupCode=='special'">
        测点：
        <el-select
          @change="getDataInfo"
          collapse-tags
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px;width: 10%;"
          clearable
          filterable
          v-model="pointId">
        <el-option
          :key="item.id"
          :label="item.name"
          :value="item.id"
          v-for="item in screenPointList">
        </el-option>
        </el-select>
      </span>
      <span style="float: right">
        <el-checkbox-group size="small" v-model="groupCode">
          <el-checkbox-button :key="item.value" :label="item.value" @touchstart.native.prevent="checkBoxChange(item)" @click.native.prevent="checkBoxChange(item)"
                              v-for="item in alarmCategory">{{ item.name }}</el-checkbox-button>
        </el-checkbox-group>
      </span>
    </el-row>
    <el-table
      :data="tableData"
      border
      class="table"
      style="width: 100%;margin-top: 10px;">
      <el-table-column
        align="center"
        label="告警类型"
        prop="groupCode">
        <template slot-scope="scope">
          <span>{{ scope.row.groupCode | changeName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="groupCode[0] === 'ordinary'"
        align="center"
        label="设备类型"
        prop="deviceCategoryName">
      </el-table-column>
      <el-table-column
        align="center"
        label="设备"
        prop="deviceName"
        v-if="groupCode[0] === 'special'">
      </el-table-column>
      <el-table-column
        align="center"
        label="测点"
        prop="pointName"
        v-if="groupCode[0] === 'special'">
      </el-table-column>
      <el-table-column
        align="center"
        label="主机"
        prop="gatewayName"
        v-if="groupCode[0] === 'gateway' || groupCode[0] === 'special'">
      </el-table-column>
      <el-table-column
        align="center"
        label="告警等级"
        prop="levelName"
       v-if="groupCode[0] !== 'special'"
      >
        <template slot-scope="scope">
          <span :style="{color: scope.row.levelColor }">{{ scope.row.levelName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div @touchstart="() => openDialog(scope.row)" @click="() => openDialog(scope.row)" class="text-center control edit d-inline-block mr-1">
            <img alt="编辑" class="d-inline-block" src="@/assets/images/icon/edit.png">
            编辑
          </div>
          <div @touchstart="() => remove(scope.row)" @click="remove(scope.row)" class="text-center control delete d-inline-block ml-1">
            <img alt="删除" src="@/assets/images/icon/delete.png">
            删除
          </div>

        </template>
      </el-table-column>
    </el-table>
    <el-row style="margin-top: 15px;text-align: center;" v-if="tableData.length > 0">
      <el-pagination
        :current-page.sync="current"
        :page-size.sync="size"
        :total="dataTotal"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next">
      </el-pagination>
    </el-row>


    <function-dialog-component
      :dialog-title="title"
      :dialogVisible.sync="deviceDialogVisible"
      @dialogClose="(data) => this.deviceDialogVisible = data"
      center
      :width="groupCode[0] === 'special' ? '65vw' : '35vw'">
      <div slot="content" style="padding: 10px 30px 20px 30px;height: 30vh">
        <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px"
                v-if="groupCode[0] === 'ordinary'">
          <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9"
                  style="line-height: 28px;text-align: right;margin-right: 10px;">设备类型：
          </el-col>
          <el-col :lg="14" :md="14" :sm="14" :xl="14" :xs="14">
            <el-select
              @change="changeCategory"
              collapse-tags
              placeholder="请选择"
              size="mini"
              style="padding-bottom: 5px;width: 60%;"
              clearable
              filterable
              v-model="category">
              <el-option
                :key="item.id"
                :label="item.cnName"
                :value="item.id"
                v-for="item in categoryList">
              </el-option>
            </el-select>
          </el-col>
        </el-col>
        <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px"
                v-if="groupCode[0] === 'gateway' ||groupCode[0] === 'special'">
          <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9"
                  style="line-height: 28px;text-align: right;margin-right: 10px;">主机：
          </el-col>
          <el-col :lg="14" :md="14" :sm="14" :xl="14" :xs="14">
            <el-select
              @change="changeGateway"
              placeholder="请选择"
              size="mini"
              style="padding-bottom: 5px;width: 60%;"
              clearable
              filterable
              :disabled="groupCode[0] === 'special' && !!selectRow && !!selectRow.id"
              v-model="gateway">
              <el-option
                :key="item.snCode"
                :label="item.name"
                :value="item.snCode"
                v-for="item in gatewayList">
              </el-option>
            </el-select>
          </el-col>
        </el-col>
        <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px"
                v-if="groupCode[0] === 'special'">
          <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9"
                  style="line-height: 28px;text-align: right;margin-right: 10px;">设备：
          </el-col>
          <el-col :lg="14" :md="14" :sm="14" :xl="14" :xs="14">
            <el-select
              @change="changeDevice"
              placeholder="请选择"
              size="mini"
              style="padding-bottom: 5px;width: 60%;"
              clearable
              filterable
              :disabled="groupCode[0] === 'special' && !!selectRow && !!selectRow.id"
              v-model="device">
              <el-option
                :key="item.id"
                :label="item.name"
                :value="item.id"
                v-for="item in deviceList">
              </el-option>
            </el-select>
          </el-col>
        </el-col>
        <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px"
                v-if="groupCode[0] === 'special'">
          <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9"
                  style="line-height: 28px;text-align: right;margin-right: 10px;">测点：
          </el-col>
          <el-col :lg="14" :md="14" :sm="14" :xl="14" :xs="14">
            <el-select
              @change="changePoint"
              collapse-tags
              placeholder="请选择"
              size="mini"
              style="padding-bottom: 5px;width: 60%;"
              clearable
              filterable
              :disabled="groupCode[0] === 'special' && !!selectRow && !!selectRow.id"
              v-model="point">
              <el-option
                :key="item.id"
                :label="item.name"
                :value="item.id"
                v-for="item in deviceMeasuringPointList">
              </el-option>
            </el-select>
          </el-col>
        </el-col>
        <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px"
                v-if="groupCode[0] !== 'special'">
          <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9"
                  style="line-height: 28px;text-align: right;margin-right: 10px;">告警等级：
          </el-col>
          <el-col :lg="14" :md="14" :sm="14" :xl="14" :xs="14">
            <el-select
              @change="changeLevel"
              collapse-tags
              placeholder="请选择"
              size="mini"
              style="padding-bottom: 5px;width: 60%;"
              clearable
              filterable
              v-model="level">
              <el-option
                :key="item.id"
                :label="item.levelName"
                :style="{color: item.levelColor}"
                :value="item.id"
                v-for="item in levelList">
              </el-option>
            </el-select>
          </el-col>
        </el-col>
        
        <!-- 特殊告警策略配置区域 -->
        <div v-if="groupCode[0] === 'special'" style="margin-top: 20px; width: 100%;padding: 20px">
          <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-bottom: 10px;">
            <el-col :lg="12" :md="12" :sm="12" :xl="12" :xs="12" style="line-height: 28px; font-weight: bold;color:#0093f7;">
              告警配置项
            </el-col>
            <el-col :lg="12" :md="12" :sm="12" :xl="12" :xs="12" style="text-align: right;">
              <el-button type="primary" style="color: #0093f7;font-weight: bold;background-color: transparent;border: 1px solid #0093f7;border-radius: 15px;" size="mini" icon="el-icon-plus" @click="addAlarmConfig">添加</el-button>
            </el-col>
          </el-col>
          
          <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" v-for="(item, index) in alarmConfigList" :key="index" style="margin-bottom: 15px; padding: 10px; border: 1px dashed #00355d; position: relative;">
            <el-col  :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="position: absolute; top: 47%; right: -35px; text-align: right;">
              <el-button type="danger" style="color: red;" size="mini" icon="el-icon-delete" circle @click="deleteAlarmConfig(index)"></el-button>
            </el-col>
            
            <!-- 第一行：告警类型、告警基值、告警上限、恢复上限 -->
            <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 15px;">
              <!-- 告警类型 -->
              <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6">
                <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="line-height: 28px;text-align: right;margin-right: 5px;">
                  告警类型：
                </el-col>
                <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
                  <el-select
                    placeholder="请选择"
                    size="mini"
                    style="padding-bottom: 5px;width: 90%;"
                    v-model="item.alarmType">
                    <el-option
                      :key="type.value"
                      :label="type.label"
                      :value="type.value"
                      v-for="type in alarmTypeOptions">
                    </el-option>
                  </el-select>
                </el-col>
              </el-col>
              
              <!-- 告警基值 -->
              <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6">
                <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="line-height: 28px;text-align: right;margin-right: 5px;">
                  告警基值：
                </el-col>
                <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
                  <el-input
                    placeholder="请输入"
                    size="mini"
                    style="padding-bottom: 5px;width: 90%;"
                    v-model="item.alarmBasic">
                  </el-input>
                </el-col>
              </el-col>
              
              <!-- 告警上限 -->
              <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6">
                <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="line-height: 28px;text-align: right;margin-right: 5px;">
                  告警上限：
                </el-col>
                <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
                  <el-input
                    placeholder="请输入"
                    size="mini"
                    style="padding-bottom: 5px;width: 90%;"
                    v-model="item.alarmHigh">
                  </el-input>
                </el-col>
              </el-col>
              
              <!-- 恢复上限 -->
              <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6">
                <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="line-height: 28px;text-align: right;margin-right: 5px;">
                  恢复上限：
                </el-col>
                <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
                  <el-input
                    placeholder="请输入"
                    size="mini"
                    style="padding-bottom: 5px;width: 90%;"
                    v-model="item.alarmRecoverHigh">
                  </el-input>
                </el-col>
              </el-col>
            </el-col>
            
            <!-- 第二行：告警下限、恢复下限、百分比、告警等级 -->
            <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 15px;">
              <!-- 告警下限 -->
              <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6">
                <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="line-height: 28px;text-align: right;margin-right: 5px;">
                  告警下限：
                </el-col>
                <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
                  <el-input
                    placeholder="请输入"
                    size="mini"
                    style="padding-bottom: 5px;width: 90%;"
                    v-model="item.alarmLow">
                  </el-input>
                </el-col>
              </el-col>
              
              <!-- 恢复下限 -->
              <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6">
                <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="line-height: 28px;text-align: right;margin-right: 5px;">
                  恢复下限：
                </el-col>
                <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
                  <el-input
                    placeholder="请输入"
                    size="mini"
                    style="padding-bottom: 5px;width: 90%;"
                    v-model="item.alarmRecoverLow">
                  </el-input>
                </el-col>
              </el-col>
              
              <!-- 百分比 -->
              <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6">
                <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="line-height: 28px;text-align: right;margin-right: 5px;">
                  百分比：
                </el-col>
                <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
                  <el-input
                    placeholder="请输入"
                    size="mini"
                    style="padding-bottom: 5px;width: 90%;"
                    v-model="item.alarmPercent"
                    @input="validatePercent(item)">
                    <template slot="append">%</template>
                  </el-input>
                </el-col>
              </el-col>
              
              <!-- 告警等级 -->
              <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6">
                <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="line-height: 28px;text-align: right;margin-right: 5px;">
                  告警等级：
                </el-col>
                <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
                  <el-select
                    placeholder="请选择"
                    size="mini"
                    style="padding-bottom: 5px;width: 90%;"
                    :disabled="groupCode[0] === 'special' && !!selectRow && !!selectRow.id && !!item.settingId"
                    v-model="item.levelId">
                    <el-option
                      :key="level.id"
                      :label="level.levelName"
                      :style="{color: level.levelColor}"
                      :value="level.id"
                      v-for="level in levelList">
                    </el-option>
                  </el-select>
                </el-col>
              </el-col>
            </el-col>
            <!-- 告警下限 -->
            <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="6" style="margin-top: 15px;">
                <el-col :lg="8" :md="8" :sm="8" :xl="8" :xs="8" style="line-height: 28px;text-align: right;margin-right: 5px;">
                  排序：
                </el-col>
                <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
                  <el-input
                    placeholder="请输入"
                    size="mini"
                    type="number"
                    style="padding-bottom: 5px;width: 90%;"
                    v-model="item.ordinal">
                  </el-input>
                </el-col>
              </el-col>
          </el-col>
          
          <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" v-if="alarmConfigList.length === 0" style="text-align: center; color: #909399; padding: 20px;">
            请点击"添加"按钮新增告警配置
          </el-col>
        </div>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;">
        <el-button @touchstart="() => {this.deviceDialogVisible = false}" @click="() => {this.deviceDialogVisible = false}" size="mini">关 闭</el-button>
        <el-button @touchstart="commit" @click="commit" size="mini" type="primary">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import {addSetting, deleteSetting, listByPage, updateSetting} from "@/network/alarm-setting";
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import {getCategoryIdList, getDeviceCategoryList} from "@/network/device-category";
import {getLevelList} from "@/network/alarm-level";
import {getDeviceListBySnCode, getUnSettingDeviceList} from "@/network/device-info";
import {gatewayList, getUnSettingList} from "@/network/device-gateway";

export default {
  name: "AlarmLevel",
  components: {FunctionDialogComponent},
  data() {
    return {
      tableData: [],
      current: 1,
      size: 10,
      dataTotal: 0,
      groupCode: ['ordinary'],
      title: "新增策略",
      deviceCategoryList: [],
      alarmCategory: [{
        name: "普通告警",
        value: 'ordinary'
      }, {
        name: "特殊告警",
        value: 'special'
      }, {
        name: "主机告警",
        value: 'gateway'
      }],
      // 告警等级
      alarmLevel: null,
      deviceCategory: null,
      gatewaySn: null,
      // 设备id
      deviceId: null,
      pointId: null,
      // 筛选用设备列表
      screenDeviceList: [],
      screenPointList: [],
      category: null,
      gateway: null,
      level: null,
      device: null,
      point: null,
      categoryList: [],
      gatewayList: [],
      deviceList: [],
      deviceMeasuringPointList: [],
      categoryAddList: [],
      categoryEditList: [],
      levelList: [],
      deviceDialogVisible: false,
      selectRow: null,
      // 设备名称
      deviceName: "",
      alarmConfigList: [], // 新增：告警配置列表
      alarmTypeOptions: [ // 新增：告警类型选项
        {label: '无告警', value: 0},
        {label: '绝对阈值', value: 1},
        {label: '百分比阈值', value: 2},
        {label: '上下限告警', value: 3},
      ],
      // 添加一个新变量用于存储真实的 gatewaySn
      realGatewaySn: null,
    }
  },
  filters: {
    changeName: function (param) {
      switch (param) {
        case 'ordinary':
          return '普通告警';
        case "special":
          return '特殊告警';
        case "gateway":
          return '主机告警'
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getDataInfo();
      this.getCategoryIdList();
      this.getLevelList();
      // 获取主机列表
      this.getAllGatewayList();
      // 获取设备类型
      this.getDeviceCategoryList();
    },
    //获取设备类型列表
    getCategoryIdList() {
      this.categoryAddList = [];
      this.categoryEditList = [];
      getCategoryIdList().then(res => {
        console.log(res, 'res');
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.categoryEditList = res.data;
            this.categoryAddList.push({id: '0', cnName: '全部'});
            res.data.forEach(item => {
              this.categoryAddList.push(item)
            })
          }
        }
      })
    },
    //获取未设置告警的设备列表
    getUnSettingDeviceList(snCode) {
      this.deviceList = [];
      getUnSettingDeviceList(snCode).then(res => {
        this.deviceList = res.data
      })
    },
    //获取等级列表
    getLevelList() {
      this.levelList = [];
      getLevelList().then(res => {
        this.levelList = res.data;
      })
    },
    // 获取设备类型
    getDeviceCategoryList() {
      getDeviceCategoryList().then(res => {
        if (res.code === 0) {
          this.deviceCategoryList = res.data;
          console.log(this.deviceCategoryList, 'this.deviceCategoryList');
        }
      });
    },
    //获取主机列表
    getGatewayList() {
      getUnSettingList().then(res => {
        this.gatewayList = res.data;
      })
    },
    //获取主机列表
    getAllGatewayList() {
      gatewayList().then(res => {
        this.gatewayList = res.data;
      })
    },
    //获取告警等级策略列表
    getDataInfo() {
      listByPage(this.current, this.size, this.groupCode[0], this.deviceCategory,
        this.alarmLevel, this.gatewaySn, this.deviceId, this.pointId).then(res => {
        if (res.code === 0) {
          this.tableData = res.data ? res.data.records : [];
          this.dataTotal = res.data ? res.data.total : 0;
        }
      })
    },
    checkBoxChange(val) {
      this.groupCode = [val.value];
      this.current = 1;
      this.deviceName = ''
      this.deviceCategory = null
      this.alarmLevel = null
      this.gatewaySn = null
      this.deviceId = null
      this.pointId = null;
      this.getDataInfo();
    },
    changeCategory(id) {
      const item = this.categoryList.filter(i => i.id === id)[0];
      this.selectRow.deviceCategoryName = item.cnName;
      this.selectRow.deviceCategoryId = item.id
    },
    changeLevel(id) {
      const item = this.levelList.filter(i => i.id === id)[0];
      this.selectRow.levelName = item.levelName;
      this.selectRow.levelId = item.id
    },
    changeGateway(snCode) {
      this.realGatewaySn = snCode; // 新增：更新真实的 gatewaySn
      
      // 判断是否为编辑模式（this.selectRow.id存在表示编辑模式）
      if (this.selectRow && this.selectRow.id) {
        // 编辑模式下，使用getDeviceListBySnCode获取完整设备列表
        getDeviceListBySnCode(snCode).then(res => {
          this.deviceList = res.data;
          
          // 如果存在设备ID，找到对应的设备并加载测点列表
          if (this.device && this.deviceList.length > 0) {
            const selectDevice = this.deviceList.filter(device => {
              return device.id === this.device;
            });
            
            if (selectDevice.length > 0) {
              this.deviceMeasuringPointList = selectDevice[0].deviceMeasuringPointList;
            }
          }
        });
      } else {
        // 新增模式下，使用原有的getUnSettingDeviceList并清空设备和测点选择
        this.device = null;
        this.point = null;
        this.deviceMeasuringPointList = [];
        this.getUnSettingDeviceList(snCode);
      }
    },
    screenGateway() {
      this.getDeviceList();
      this.getDataInfo();
    },
    getDeviceList() {
      if (!this.gatewaySn) {
        this.screenDeviceList = []
        return
      }
      getDeviceListBySnCode(this.gatewaySn).then(res => {
        this.screenDeviceList = res.data
      });
    },
    changeDeviceId() {
      this.getDataInfo();
      if (!this.deviceId) {
        this.screenPointList = [];
        this.pointId = null;
        return;
      }
      
      const selectDevice = this.screenDeviceList.filter(device => {
        return device.id === this.deviceId;
      });
      
      if (selectDevice.length > 0) {
        this.screenPointList = selectDevice[0].deviceMeasuringPointList;
        
        // 如果在编辑模式下且有点ID，检查是否在列表中存在，如果存在则自动选中
        if (this.groupCode[0] === 'special' && this.pointId) {
          const pointExists = this.screenPointList.some(p => p.id === this.pointId);
          if (!pointExists) {
            this.pointId = null;  // 如果不存在，清空选择
          }
        }
      } else {
        this.screenPointList = [];
        this.pointId = null;
      }
    },
    changeDevice(id) {
      const item = this.deviceList.filter(i => i.id === id)[0];
      if (item) {
        this.point = null;
        this.selectRow.deviceName = item.name;
        this.selectRow.deviceId = item.id;
        const selectDevice = this.deviceList.filter(device => {
          return device.id === item.id;
        });
        if (selectDevice.length > 0) {
          this.deviceMeasuringPointList = selectDevice[0].deviceMeasuringPointList;
          
          // 如果处于编辑模式且有测点ID，自动选中对应的测点
          if (this.selectRow.id && this.selectRow.pointId && this.deviceMeasuringPointList) {
            const pointExists = this.deviceMeasuringPointList.some(p => p.id === this.selectRow.pointId);
            if (pointExists) {
              this.point = this.selectRow.pointId;
            }
          }
        }
      }
    },
    changePoint(id) {
      const item = this.deviceMeasuringPointList.filter(i => i.id === id)[0];
      this.selectRow.pointName = item.name;
      this.selectRow.pointId = item.id
    },
    handleCurrentChange(val) {
      //当前为第几页时调用getData()显示第几页数据
      this.current = val;
      this.size = 10;
      this.getDataInfo();
    },
    openDialog(row) {
      if (row) {
        this.level = row.levelId;
        this.category = row.deviceCategoryName;
        this.device = row.deviceId;
        this.point = row.pointId;
        this.gateway = row.gatewayName;
        this.realGatewaySn = JSON.parse(JSON.stringify(row.gatewaySn)); // 新增：保存真实的 gatewaySn
        this.selectRow = JSON.parse(JSON.stringify(row));
        this.categoryList = this.categoryEditList;
        if (this.realGatewaySn) {
          getDeviceListBySnCode(this.realGatewaySn).then(res => {
            this.deviceList = res.data;
            
            // 加载完设备列表后，如果有设备ID，找到对应的设备并加载测点列表
            if (this.device && this.deviceList.length > 0) {
              const selectDevice = this.deviceList.filter(device => {
                return device.id === this.device;
              });
              
              if (selectDevice.length > 0) {
                this.deviceMeasuringPointList = selectDevice[0].deviceMeasuringPointList;
              }
            }
          });
        }
        
        // 如果是编辑特殊告警，加载已有告警配置
        if (this.groupCode[0] === 'special' && row.alarmSettingDetailList) {
          this.alarmConfigList = JSON.parse(JSON.stringify(row.alarmSettingDetailList || []));
          
        } else {
          this.alarmConfigList = [];
        }
        
        if (this.groupCode[0] === 'ordinary') {
          this.title = "编辑普通告警策略";
        } else if (this.groupCode[0] === 'gateway') {
          this.title = "编辑主机告警策略";
          this.getGatewayList();
        } else {
          this.title = "编辑特殊告警策略";
          this.getAllGatewayList();
        }
      } else {
        this.level = null;
        this.category = null;
        this.device = null;
        this.point = null;
        this.gateway = null;
        this.realGatewaySn = null; // 新增：清空真实的 gatewaySn
        this.selectRow = {};
        this.deviceMeasuringPointList = {};
        this.categoryList = this.categoryAddList;
        this.alarmConfigList = []; // 清空告警配置列表
        
        if (this.groupCode[0] === 'ordinary') {
          this.title = "新增普通告警策略";
        } else if (this.groupCode[0] === 'gateway') {
          this.title = "新增主机告警策略";
          this.getGatewayList();
        } else {
          this.title = "新增特殊告警策略";
          this.getAllGatewayList();
        }
      }
      this.deviceDialogVisible = true;
    },
    commit() {
      if (this.groupCode[0] === 'ordinary') {
        if (this.level) {
          if (this.category) {
            this.createStrategy();
          } else {
            this.$message.error("请选择设备类型!")
          }
          return;
        } else {
          this.$message.error("请选择告警等级!");
          return;
        }
      } else if (this.groupCode[0] === 'special') {
        if (this.device != null) {
          console.log(this.alarmConfigList, 'this.alarmConfigList');
          if (this.point) {
            // 特殊告警策略需要验证配置列表
            if (this.alarmConfigList.length === 0) {
              this.$message.error("请至少添加一项告警配置!");
              return;
            }
            
            // 验证每个告警配置的必填项
            for (let i = 0; i < this.alarmConfigList.length; i++) {
              const config = this.alarmConfigList[i];
              if (!config.alarmType && config.alarmType !== 0) {
                this.$message.error(`第${i+1}项告警配置缺少告警类型!`);
                return;
              }
              // 移除对levelId的检查，因为新结构中不包含此字段
            }
            
            // 将告警配置列表添加到提交数据中
            this.selectRow.alarmSettingDetailList = this.alarmConfigList;
            this.createStrategy();
          } else {
            this.$message.error("请选择测点!");
          }
          return;
        } else {
          this.$message.error("请选择设备!");
          return;
        }
      } else {
        if (this.level) {
          if (this.gateway) {
            this.createStrategy();
            return;
          } else {
            this.$message.error("请选择主机!");
            return;
          }
        } else {
          this.$message.error("请选择告警等级!");
          return;
        }
      }
    },
    createStrategy() {
      if (this.selectRow.id) {
        this.category = this.selectRow.deviceCategory;
        let data = [];
        if (this.groupCode[0] === 'special') {
          const AlarmSettingDetailList = this.selectRow.alarmSettingDetailList;
          const { alarmSettingDetailList, id, ...rest } = this.selectRow;
          console.log(alarmSettingDetailList,id);
          AlarmSettingDetailList.forEach((item, index) => {
            delete item.id;
            item.ordinal = Number(item.ordinal)
            if (!item.settingId) {
              data.push({
                alarmSettingDetail: item,
                ...rest,
                gatewaySn: this.realGatewaySn || this.gateway, // 使用真实的 gatewaySn
                deviceId: this.device,
                pointId: this.point,
                levelId: AlarmSettingDetailList[index].levelId,
                ordinal: item.ordinal, // 与alarmSettingDetail同级的ordinal字段
              });
            } else {
              data.push({
                alarmSettingDetail: item,
                ...rest,
                gatewaySn: this.realGatewaySn || this.gateway, // 使用真实的 gatewaySn
                deviceId: this.device,
                pointId: this.point,
                levelId: AlarmSettingDetailList[index].levelId,
                ordinal: item.ordinal, // 与alarmSettingDetail同级的ordinal字段
              });
            }
          })
        } else {
          data = [this.selectRow];
          data[0].deviceCategoryList = this.categoryEditList.filter(item => item.id === this.selectRow.deviceCategoryId);
          data[0].gatewaySn = this.realGatewaySn || this.gateway;
        }
        updateSetting(data).then(res => {
          if (res.code === 0) {
            this.$message.success("编辑成功!");
            this.deviceDialogVisible = false;
            this.init();
          } else {
            this.$message.error("编辑失败!")
          }
        })
      } else {
        this.selectRow.groupCode = this.groupCode[0];
        this.selectRow.isUpgrade = false;
        this.selectRow.needWorkOrder = false;
        let data = [];
        if (this.groupCode[0] === 'special') {
          const AlarmSettingDetailList = this.selectRow.alarmSettingDetailList;
          const { alarmSettingDetailList, ...rest } = this.selectRow;
          console.log(alarmSettingDetailList);
          AlarmSettingDetailList.forEach((item, index) => {
            item.ordinal = Number(item.ordinal)
            data.push({
              alarmSettingDetail: item,
              ...rest,
              gatewaySn: this.realGatewaySn || this.gateway, // 使用真实的 gatewaySn
              deviceId: this.device,
              pointId: this.point,
              levelId: AlarmSettingDetailList[index].levelId,
              ordinal: item.ordinal, // 与alarmSettingDetail同级的ordinal字段
              deviceCategoryList: null
            });
          })
        } else {
          data = [this.selectRow];
          data[0].deviceCategoryList = this.categoryEditList.filter(item => item.id === this.selectRow.deviceCategoryId);
          data[0].gatewaySn = this.realGatewaySn || this.gateway;
        }
        if (this.category === '0') {
          data[0].deviceCategoryList = this.categoryEditList;
        }
        console.log(data, 'data');
        addSetting(data).then(res => {
          if (res.code === 0) {
            this.$message.success("新增成功!");
            this.deviceDialogVisible = false;
            this.init();
          } else {
            this.$message.error("新增失败!");
          }
        })
      }
    },
    remove(row) {
      this.$confirm('是否确认删除', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            deleteSetting({groupCode: this.groupCode[0], pointId: row.pointId || '', id: row.id}).then(res => {
              if (res.code === 0) {
                this.$message.success("删除成功");
                this.init();
              } else {
                this.$message.error('删除失败');
              }
            })
          }
        }
      })
    },
    addAlarmConfig() {
      this.alarmConfigList.push({
        alarmType: '',
        alarmBasic: '',
        alarmHigh: '',
        alarmLow: '',
        alarmPercent: '',
        alarmRecoverHigh: '',
        alarmRecoverLow: '',
        ordinal: '',
      });
    },
    deleteAlarmConfig(index) {
      this.$confirm('是否确认删除此告警配置？', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            this.alarmConfigList.splice(index, 1);
          }
        }
      });
    },
    validatePercent(item) {
      if (item.alarmPercent !== '') {
        const num = parseFloat(item.alarmPercent);
        if (isNaN(num) || num < 0 || num > 100) {
          item.alarmPercent = '';
          this.$message.error('百分比必须为0-100之间的数字');
        }
      }
    }
  }
}
</script>

<style scoped>

.control img {
  margin-top: -5px;
}

.control.edit:hover {
  cursor: pointer;
  color: #299FFB;
}

.control.delete:hover {
  cursor: pointer;
  color: #fb2929;
}
::v-deep .el-input-group__append {
  background-color: transparent;
  color: #fff;
  border: 1px solid rgba(41, 155, 255, .3);
  border-left: none;
}
</style>
